module.exports = __webpack_public_path__ + "static/media/golden-frame-custom-mat-rendering.7b9695bf.jpg";